/**
 * アンカーリンク・アンカーメニュー制御モジュール
 *
 * - AnchorScroll: .js-anchor等のリンクでスムーススクロールを実現
 * - AnchorMenu: アンカーメニューの開閉・自動クローズを制御
 *
 * @example
 *   const anchor = new AnchorScroll();
 *   anchor.init();
 *
 *   const menu = new AnchorMenu();
 *   menu.init();
 *
 * 注意:
 * - セレクタやクラス名はHTML構造に合わせて調整
 */
export class AnchorScroll {
	constructor(selector = '.js-anchor') {
		this.links = document.querySelectorAll(selector);
	}

	/**
	 * 対象リンクにクリックイベント登録
	 */
	init() {
		this.links.forEach((link) => {
			link.addEventListener('click', (e) => this.handleClick(e, link));
		});
	}

	/**
	 * クリック時にスムーススクロールを実行
	 * @param {Event} event クリックイベント
	 * @param {Element} link クリックされたリンク
	 */
	handleClick(event, link) {
		event.preventDefault();

		const targetId = link.getAttribute('href');
		const targetElement = document.querySelector(targetId);
		if (!targetElement) return;

		const targetPosition = targetElement.offsetTop;

		// ネイティブのスムーススクロール
		window.scrollTo({
			top: targetPosition,
			behavior: 'smooth',
		});
	}
}

/**
 * アンカーメニューの開閉・自動クローズ制御
 */
export class AnchorMenu {
	constructor({
		triggerSelector = '.js-anchor-trigger',
		listSelector = '.js-anchor-list',
		anchorSelector = '.js-anchor',
		openClass = '-open',
	} = {}) {
		this.trigger = document.querySelector(triggerSelector);
		this.list = document.querySelector(listSelector);
		this.anchors = document.querySelectorAll(anchorSelector);
		this.openClass = openClass;
	}

	/**
	 * トリガー・アンカーにイベント登録
	 */
	init() {
		if (this.trigger && this.list) {
			this.trigger.addEventListener('click', (e) => this.toggleMenu(e));
		}

		if (this.anchors.length > 0) {
			this.anchors.forEach((anchor) => {
				anchor.addEventListener('click', () => this.closeMenu());
			});
		}
	}

	/**
	 * メニューの開閉トグル
	 * @param {Event} event クリックイベント
	 */
	toggleMenu(event) {
		event.preventDefault();
		this.trigger.classList.toggle(this.openClass);
		this.list.classList.toggle(this.openClass);
	}

	/**
	 * メニューを閉じる
	 */
	closeMenu() {
		this.trigger.classList.remove(this.openClass);
		this.list.classList.remove(this.openClass);
	}
}
